var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('InterBtnBox',{attrs:{"printBusinessType":2},on:{"overEmit":_vm.getDataSource}}),_c('InterList',{attrs:{"dataSource":_vm.dataSource,"printBusinessType":2},on:{"overEmit":_vm.getDataSource}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }